import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import { base_url } from "../../utils/AxiosConfig";
import UploadSealSignPopup from "./UploadSealSignPopup";
import ViewUploadedSealSignPopup from "./ViewUploadedSealSignPopup";
import ic_clone from './ic_clone.png'

const UserList = ({ onEditUser , setShowClonePopup , setClickedUserFromList }) => {
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [showViewPopup, setShowViewPopup] = useState(false);
  const [currentDetailsForImageUpload, setCurrentDetailsForImageUpload] =
    useState(null);

  const userDataArrayFromLocal = JSON.parse(
    localStorage.getItem("BondTimeuserDataArray") || "-",
  );
  const COMPANY_CODE = userDataArrayFromLocal?.[0]?.cmpcode;

  console.log("COMPANY_CODE:", COMPANY_CODE);

  const fetchUsers = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${base_url}/api/CpaysCount/${COMPANY_CODE}/USERLIST/-/-`,
      );

      console.log("User List:", response.data);

      setUsers(response.data || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const filteredUsers = useMemo(() => {
    return users.filter((user) => {
      const searchTerm = search.toLowerCase();

      return (
        user?.loginame?.toLowerCase()?.includes(searchTerm) ||
        user?.accessgrp?.toLowerCase()?.includes(searchTerm) ||
        user?.empcode?.toLowerCase()?.includes(searchTerm)
      );
    });
  }, [users, search]);

  const handleEdit = (user) => {
    console.log("Edit User:", user);
    if (onEditUser) onEditUser(user);
  };

  const handleDelete = (user) => {
    console.log("Delete User:", user);
  };

  return (
    <>
      {/* Header */}
      <div className="flex justify-between items-center mb-4 flex-wrap gap-3">
        <div className="flex items-center">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full mr-2"></div>

          <h6 className="text-xl font-bold text-gray-900">
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              USER LIST
            </span>
          </h6>
        </div>

        {/* Search */}
        <div className="mr-2 bg-white w-[350px] flex items-center gap-2 p-2 border border-gray-300 rounded-md transition-all duration-200 focus-within:ring-2 focus-within:ring-[#2663EB]/20">
          <FaSearch className="text-gray-400 text-sm" />

          <input
            type="text"
            placeholder="Search by Name, Role or Emp Code..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-white outline-none text-sm text-gray-700 placeholder-gray-400 "
          />

          {search && (
            <button
              onClick={() => setSearch("")}
              className="text-gray-400 hover:text-red-500 text-sm"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {/* Table */}
      <div className="overflow-auto max-h-[75vh] border scrollbar-none bg-white rounded-md">
        {loading ? (
          <div className="flex justify-center items-center py-10">
            <p className="text-gray-500">Loading Users...</p>
          </div>
        ) : (
          <div className="h-[50vh] overflow-auto scrollbar-none">
            <table className="min-w-full ">
              <thead className="sticky top-0 z-20">
                <tr className="bg-[#2663EB] text-white text-sm">
                  <th className="px-3 py-2 text-left">Sl No</th>
                  <th className="px-3 py-2 text-left">Employee Code</th>
                  <th className="px-3 py-2 text-left">Username</th>
                  <th className="px-3 py-2 text-left">Password</th>
                  <th className="px-3 py-2 text-left">Role</th>
                  <th className="px-3 py-2 text-center">Actions</th>
                </tr>
              </thead>

              <tbody className="text-sm text-gray-700">
                {filteredUsers?.length > 0 ? (
                  filteredUsers.map((user, index) => (
                    <tr
                      key={index}
                      onClick={() => setSelectedUser(user)}
                      className={` cursor-pointer transition-colors duration-150 ${
                        selectedUser === user
                          ? "bg-blue-50"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <td className="px-3 py-2 border">{index + 1}</td>

                      <td className="px-3 py-2 border">
                        {user?.empcode || "-"}
                      </td>

                      <td className="px-3 py-2 border">
                        {user?.loginame || "-"}
                      </td>

                      <td className="px-3 py-2 border">
                        {user?.loginpwd || "-"}
                      </td>

                      <td className="px-3 py-2 border">
                        {user?.accessgrp || "-"}
                      </td>

                      <td className="px-3 py-2 border">
                        <div className="flex justify-center items-center gap-2">
                          <a
                            style={{
                              display: "flex",
                              alignItems: "center",
                              fontSize: "14px",
                              marginLeft: "10px",
                            }}
                            className=" px-1"
                            href={`user_rights?user_name=${encodeURIComponent(
                              user.loginame?.trim(),
                            )}`}
                            class="text-black-600 hover:text-black-900"
                          >
                            <svg
                              style={{ marginRight: "4px" }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              class="feather feather-eye"
                            >
                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                              <circle cx="12" cy="12" r="3" />
                            </svg>
                            Rights
                          </a>

                           <button
                        onClick={() => {
                          setClickedUserFromList(user);
                          setShowClonePopup((prev) => !prev);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "14px",
                          marginLeft: "10px",
                        }}
                        className="  px-1"
                        class="text-blue-800 hover:text-blue-900"
                      >
                        <img
                          width="24"
                          height="24"
                          className=""
                          src={ic_clone}
                        />
                        Clone
                      </button>

                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(user);
                            }}
                            className="p-2 rounded bg-blue-500 text-white hover:bg-blue-600"
                          >
                            <div className="flex justify-center items-center gap-2">

                            <FaEdit size={12} />
                            <span>

                            Edit
                            </span>
                            </div>
                          </button>

                          {/* <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(user);
                            }}
                            className="p-2 rounded bg-red-500 text-white hover:bg-red-600"
                          >
                            <FaTrash size={12} />
                          </button> */}

                          <div className="flex ">
                            <button
                              onClick={() => {
                                setShowUploadPopup(true);
                                setCurrentDetailsForImageUpload({
                                  userObject: user,
                                  image_doc_type: "SIGNATURE",
                                });
                              }}
                              className="flex items-center gap-2 px-1 py-0.5 text-xs font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 hover:text-blue-900 transition-colors ml-2"
                            >
                              Upload Signature
                            </button>

                            <button
                              onClick={() => {
                                setShowViewPopup(true);
                                setCurrentDetailsForImageUpload({
                                  userObject: user,
                                  image_doc_type: "SIGNATURE",
                                });
                              }}
                              className="flex items-center gap-2 px-1 py-0.5 text-xs font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 hover:text-blue-900 transition-colors ml-2"
                            >
                              View Signature
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-6 text-gray-500">
                      No Users Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <UploadSealSignPopup
        isOpen={showUploadPopup}
        onClose={() => setShowUploadPopup(false)}
        currentDetailsForImageUpload={currentDetailsForImageUpload}
      />

      <ViewUploadedSealSignPopup
        isOpen={showViewPopup}
        onClose={() => setShowViewPopup(false)}
        currentDetailsForImageUpload={currentDetailsForImageUpload}
        title="View Seal"
      />
    </>
  );
};

export default UserList;
